import React from 'react';

interface DemoWaveformProps {
  /** Whether audio is currently playing */
  playing: boolean;
  /** Number of dots */
  dots?: number;
}

/**
 * Dot-based voice activity indicator.
 * Dots bounce when audio is playing, freeze in place when paused/idle.
 * Pure CSS animation with animation-play-state for pause support.
 */
export const DemoWaveform: React.FC<DemoWaveformProps> = ({ playing, dots = 4 }) => {
  return (
    <>
      <style>{`
        @keyframes demo-dot-bounce {
          0%, 100% { transform: translateY(0); opacity: 0.4; }
          50% { transform: translateY(-5px); opacity: 1; }
        }
      `}</style>
      <div className="flex items-center gap-[3px] h-4 px-0.5">
        {Array.from({ length: dots }).map((_, i) => (
          <div
            key={i}
            className="rounded-full bg-emerald-400 transition-all duration-300"
            style={{
              width: playing ? 5 : 4,
              height: playing ? 5 : 4,
              animation: playing ? 'demo-dot-bounce 1.2s ease-in-out infinite' : 'none',
              animationDelay: `${i * 0.15}s`,
              opacity: playing ? undefined : 0.3,
            }}
          />
        ))}
      </div>
    </>
  );
};
